import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationDataSource } from '../../services/notification-data-source';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'new-notification-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class NewNotification implements OnInit {
  public loading: boolean;
  public form: FormGroup;
  public dataSource: NotificationDataSource;

  constructor(
    private fb: FormBuilder,
    protected dialogRef: MatDialogRef<NewNotification>,
    @Inject(MAT_DIALOG_DATA) public DataSource: NotificationDataSource,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {
    this.dataSource = data.DataSource;
  }

  ngOnInit() {
    this.form = this.fb.group({
      title: [null, [Validators.required]],
      text: [null, [Validators.required]],
      image: [null, null],
      url: [null, null],
    });
  }

  onSubmit() {
    const notification = this.form.getRawValue();

    this.form.disable();
    this.dataSource.sendNotification(notification).then(
      (data) => {
        this.dialogRef.close();
      },
      (error) => this.form.enable()
    );
  }
}
